import React from 'react'


const Error = () => {
  return (
    <div>
     
        <h1 className='text-6xl font-bold'> 404-Page Not Found</h1>
    </div>
  )
}

export default Error